import { Component, inject, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SignupService } from '@services/signup/signup.service';
import { StorageService } from '@services/storage/storage.service';
import { EventsService } from '@services/events/events.service';

@Component({
  selector: 'app-startfundraiser-button',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule
  ],
  templateUrl: './startfundraiser-button.component.html',
  styleUrls: ['./startfundraiser-button.component.scss']
})
export class StartfundraiserButtonComponent {

  private readonly signupService = inject(SignupService);
  private readonly storage = inject(StorageService);
  private readonly events = inject(EventsService);

  @Input() public pageName;
  @Input() public info2;
  @Input() public info;
  @Input() public width;
  @Input() public height;
  @Input() public font;
  @Input() public lineHeight;
  @Input() public label;
  @Input() public platformFee;


  /*Event for start a fundraiser banner button */
  sendEvent(language) {
    this.storage.add('language', language);
    this.events.userGTMEvents({
      event: 'start_fundraiser',
      event_category: 'cta',
      event_action: 'start a fundraiser',
      event_label: `${this.label}|${window.location.href}`
    });
    if (language === 'Hindi') {
      this.pageName = 'home';
      this.info2 = 'home_1_hindi';

    }
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.pageName,
      info_1: 'type',
      info_2: this.info2
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
    this.storage.checkFromSession('sac-initiated', payload);
    this.signupService.startFR();
  }

}
